<template>
  <div>
    <collection-image-create
      :ams_template="ams_template"
      :reroute="reroute"
      :filtering="filtering"
    >
    </collection-image-create>
  </div>
</template>

<script>
import CollectionImageCreate from './CollectionImageCreate.vue'

export default {
  components: {
    CollectionImageCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    },
    filtering: {
      Type: Object
    }
  }
}
</script>